import React from 'react'
// import { Link } from 'gatsby';

import Layout from '../components/layout'
import SEO from '../components/seo'

import Bench from '../images/img (2).jpg'
import Image2 from '../images/internalfinishes.jpg'
import NewStore from '../images/newstorecen.jpg'
import Bakery from '../images/bakery.jpg'
import Upgrades from '../images/upgrades.jpg'

const ServicesPage = () => (
  <Layout>
    <SEO title='Services' />
    <div className='container'>
      <h1 className='d-block text-center display-3'>Services</h1>
      <div className='d-block text-center mt-3'>
        <p className='lead'>
          We can be highly adaptable and are able to react quickly to new
          challenges. <br />A brief outline of some of the services we offer
        </p>
      </div>
      <ul className='list-unstyled'>
        {/* SECTION 1 */}
        <li className='media'>
          <div className='container'>
            <div className='row d-flex align-items-center'>
              <div className='col-md-4'>
                <img
                  src={NewStore}
                  className='mr-3 mb-4 img-thumbnail'
                  alt='...'
                  style={{ width: '100%' }}
                />
              </div>
              <div className='col-md-8'>
                <h5 className='mt-0 mb-1'>New Store Fit Outs</h5>
                <p className='mb-4'>
                  Whether it be purpose built developer shells, retail parks,
                  high streets or complete strip out and refurbishment of an
                  existing store, this is our bread and butter. We do it well,
                  we do it to a high standard of finish and at a price that is
                  competetive with anyone on the market.
                </p>
              </div>
            </div>
          </div>
        </li>
        <hr />

        {/* SECTION 2 */}
        <li className='media  mt-5'>
          <div className='container'>
            <div className='row d-flex align-items-center'>
              <div className='col-md-8 '>
                <h5 className='mt-0 mb-1'>New Builds and Extensions</h5>
                <p className='mb-4'>
                  We are able to provide a complete package and to work with you
                  from design to completion with new builds, extensions and
                  refurbishments. With a wide range of experience across a
                  variety of industries we understand the difficulties of
                  working around trading stores and will work with you to ensure
                  minimal disruption and maximum trading time.
                </p>
              </div>
              <div className='col-md-4'>
                <img
                  src={Image2}
                  className='mr-3 mb-4 img-thumbnail'
                  alt='...'
                  style={{ width: '100%' }}
                />
              </div>
            </div>
          </div>
        </li>
        <hr />
        {/* SECTION 3 */}
        <li className='media  mt-5'>
          <div className='container'>
            <div className='row d-flex align-items-center'>
              <div className='col-md-4'>
                <img
                  src={Bakery}
                  className='mr-3 mb-4 img-thumbnail'
                  alt='...'
                  style={{ width: '100%' }}
                />
              </div>
              <div className='col-md-8'>
                <h5 className='mt-0 mb-1'>Nationwide Rollouts</h5>
                <p className='mb-4'>
                  We are highly adaptable and able to quickly put together
                  specialist teams to carry out installations nationwide.
                  Whether it is a handful to hundreds of sites. Just a few
                  examples would include bakery installations, coffee machines,
                  lighting installs, ventilation works, specialist joinery
                  works, remerches and rebranding.
                </p>
              </div>
            </div>
          </div>
        </li>
        <hr />
        {/* SECTION 4 */}
        <li className='media  mt-5'>
          <div className='container'>
            <div className='row d-flex align-items-center'>
              <div className='col-md-8'>
                <h5 className='mt-0 mb-1'>
                  Specialist Joinery and Packing Benches
                </h5>
                <p className='mb-4'>
                  Fabricated offsite to miminise the installation time and
                  disruption onsite, we are able to provide a variety of
                  benches, packing shelves, trolley bays and specialist joinery
                  to your requirements.
                </p>
              </div>
              <div className='col-md-4'>
                <img
                  src={Bench}
                  className='mr-3 mb-4 img-thumbnail'
                  alt='...'
                  style={{ width: '100%' }}
                />
              </div>
            </div>
          </div>
        </li>
        <hr />
        {/* SECTION 5 */}
        <li className='media  mt-5'>
          <div className='container'>
            <div className='row d-flex align-items-center'>
              <div className='col-md-4'>
                <img
                  src={Upgrades}
                  className='mr-3 mb-4 img-thumbnail'
                  alt='...'
                  style={{ width: '100%' }}
                />
              </div>
              <div className='col-md-8 '>
                <h5 className='mt-0 mb-1'>
                  Power Upgrades and Utility Connections
                </h5>
                <p className='mb-4'>
                  Power and utility upgrade works can be tricky, complex and
                  time consuming. We can help to manage this process for you
                  from start to completion, including provision and set up of
                  generators to keep trade going and handling the switch over
                  works.
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </Layout>
)

export default ServicesPage
